import type {
  IResetPasswordRequest,
  ISendRecoveryCodeRequest,
  IVerifyCodeRequest,
  IVerifyCodeResponse,
} from '../types/ForgotPassword';
import {
  OTP_TYPE_RESET_PASSWORD,
  type IResetPasswordApiPayload,
  type ISendOtpApiPayload,
  type IVerifyOtpApiPayload,
  type IVerifyOtpApiResponse,
} from '../types/ForgotPassword.api';

const toSendOtpPayload = (input: ISendRecoveryCodeRequest): ISendOtpApiPayload => ({
  otpType: OTP_TYPE_RESET_PASSWORD,
  identifier: input.identifier,
});

const toVerifyOtpPayload = (input: IVerifyCodeRequest): IVerifyOtpApiPayload => ({
  otpType: OTP_TYPE_RESET_PASSWORD,
  identifier: input.identifier,
  otpCode: input.otpCode,
});

const toVerifyCodeResponse = (apiResponse: IVerifyOtpApiResponse): IVerifyCodeResponse => ({
  requestToken: apiResponse.requestToken,
});

const toResetPasswordPayload = (input: IResetPasswordRequest): IResetPasswordApiPayload => ({
  identifier: input.identifier,
  requestToken: input.requestToken,
  newPassword: input.newPassword,
});

export const ForgotPasswordAdapters = {
  toSendOtpPayload,
  toVerifyOtpPayload,
  toVerifyCodeResponse,
  toResetPasswordPayload,
};
